// src/components/Screen8_ThankYou.jsx
import React from 'react';

function Screen8_ThankYou() {

    return (
        <div id="screen-8-thankyou" className="screen screen_padding">
            <div className="text-center py-16">
                <i className="fas fa-check-circle text-green-500 text-6xl mb-6"></i>
                <h2 className="text-3xl font-bold mb-4 title_style">Thank you for your submission!</h2>
                <p className="text-lg mb-10 title_style">Show this screen to our crew & redeem gift now</p>

                {/* --- NEW CONTENT --- */}
                <br />
                <p className="text-red-400">
                    <a 
                        href="fb://page/183132494887148" 
                        target="_blank"
                        rel="noopener noreferrer" // Added for security with target="_blank"
                        onClick={() => {
                            // This timeout acts as a fallback
                            setTimeout(() => {
                                window.location = 'https://www.facebook.com/malaysiacaroftheyear';
                            }, 500);
                        }}
                    >
                        FOLLOW US ON Facebook
                    </a>
                </p>
                {/* --- END NEW CONTENT --- */}

                {/* Restart button removed */}
            </div>
        </div>
    );
}

export default Screen8_ThankYou;